import { fetchMarketPlaceServicesApi } from 'utils/API/Merchant APIs/MerchantApiCalls';
import ServiceCard from '../../../ui-component/cards/marketPlaceCards/MarketplaceCard';
import styles from './MarketPlaceServices.module.css';
import { useEffect } from 'react';
import { useState } from 'react';
import Spinner from 'views/Components/LoadingSinner';
import { useLocation, useNavigate } from 'react-router';
import { Skeleton } from '@mui/material';
import BcConvertModal from 'views/Components/BcConvertModal';
import { useDispatch, useSelector } from 'react-redux';
import { checkIsMerchantOrBcGlobal } from 'redux/merchantSlice';

const MarketPlaceService = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { agentType, pendingStatus } = useSelector((state) => state.merchant);
    const merchantModalOpen = agentType === 'Merchant';
    const isBcConvertPending = pendingStatus;
    const shouldshowEsign = localStorage.getItem('shouldshowEsign');
    const [marketPlaceList, setMarketPlaceList] = useState({ list: [], loading: false, currentCategory: {} });
    //handler functions>>>
    const handleClickService = (service) => {
        const isMobileView = window.innerWidth <= 768; // common mobile breakpoint
        const targetRoute = isMobileView ? '/marketplace-mobile/addNewCustomerEntry' : '/marketplace/addNewCustomerEntry';
        navigate(targetRoute, { state: { service } });
    };

    //api calls>>>
    const getMarketPlaces = async () => {
        const isMobileView = window.innerWidth <= 768;
        setMarketPlaceList((prev) => ({ ...prev, loading: true }));
        const selectedCategory = location?.state?.service;
        setMarketPlaceList((prev) => ({ ...prev, currentCategory: selectedCategory }));
        const params = { category: isMobileView ? selectedCategory : selectedCategory?.name };
        const response = await fetchMarketPlaceServicesApi(params);
        if (response.status === 200) {
            const marketPlaceList = response?.data?.data;
            setMarketPlaceList((prev) => ({ ...prev, list: marketPlaceList }));
        }
        setMarketPlaceList((prev) => ({ ...prev, loading: false }));
    };
    //useEffects>>>
    useEffect(() => {
        getMarketPlaces();
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        dispatch(checkIsMerchantOrBcGlobal());
    }, [dispatch]);
    return (
        <>
            <div className={styles.wrapper}>
                <h2 className={styles.heading}>💼 Explore Our Services</h2>
                {marketPlaceList.currentCategory?.name && (
                    <p className={styles.subheading}>Category: {marketPlaceList.currentCategory.name}</p>
                )}
                <div className={styles.grid}>
                    {marketPlaceList.loading
                        ? [...Array(6)].map((_, index) => (
                              <div key={index} className={styles.card}>
                                  <Skeleton variant="rectangular" width="100%" height={100} />
                                  <Skeleton variant="text" width="60%" style={{ marginTop: 8 }} />
                              </div>
                          ))
                        : marketPlaceList.list?.map((service, index) => (
                              <ServiceCard key={index} {...service} onClick={() => handleClickService(service)} />
                          ))}
                </div>
                <Spinner loading={marketPlaceList.loading} />
            </div>
            {merchantModalOpen && (
                <BcConvertModal
                    isOpen={merchantModalOpen}
                    // handleclose={handleBcModalClose}
                    isPending={isBcConvertPending}
                    shouldshowEsign={shouldshowEsign}
                />
            )}
        </>
    );
};

export default MarketPlaceService;
